import { Banknote, ShoppingBasket, Shirt, Package, Users, Store, Sun, RefreshCw, Clock3, Hourglass, CalendarDays } from "lucide-react";

export const DISTRICTS = ["Port Louis", "Pamplemousses", "Rivière du Rempart", "Flacq", "Grand Port", "Savanne", "Plaines Wilhems", "Moka", "Black River", "Rodrigues"];

export const CATEGORIES = [
  { v: "cashier", icon: Banknote },
  { v: "sales", icon: Shirt },
  { v: "shelf", icon: ShoppingBasket },
  { v: "storekeeper", icon: Package },
  { v: "supervisor", icon: Users },
  { v: "other", icon: Store },
];

export const HOURS = [
  { v: "normal", icon: Sun },
  { v: "shift", icon: RefreshCw },
  { v: "overtime", icon: Clock3 },
  { v: "part_time", icon: Hourglass },
  { v: "weekends", icon: CalendarDays },
];

export const EXPERIENCE = ["none", "lt1", "1to3", "gt3"];
export const AVAILABILITY = ["now", "2weeks", "1month"];
export const LANGUAGES = ["creole", "french", "english", "hindi"];
export const SHOP_TYPES = ["supermarket", "boutique", "hardware", "pharmacy", "electronics", "other"];
export const STATUSES = ["new", "contact", "interview", "hired", "not_selected"];

export const STATUS_STYLE = {
  new: "bg-blue-50 text-blue-700 border-blue-200",
  contact: "bg-violet-50 text-violet-700 border-violet-200",
  interview: "bg-amber-50 text-amber-800 border-amber-200",
  hired: "bg-emerald-50 text-emerald-700 border-emerald-200",
  not_selected: "bg-red-50 text-red-700 border-red-200",
  pending: "bg-amber-50 text-amber-800 border-amber-200",
  active: "bg-emerald-50 text-emerald-700 border-emerald-200",
  rejected: "bg-red-50 text-red-700 border-red-200",
};

export const IMG = {
  team: { src: "/img/team-1280.webp", srcSet: "/img/team-640.webp 640w, /img/team-1280.webp 1280w", fr: "Équipe de vendeurs souriants dans une boutique à Maurice", en: "Smiling retail team in a boutique in Mauritius" },
  shelves: { src: "/img/shelves-1280.webp", srcSet: "/img/shelves-640.webp 640w, /img/shelves-1280.webp 1280w", fr: "Employés qui remplissent les rayons d'un supermarché", en: "Retail workers stocking supermarket shelves" },
  hero: { src: "/img/boutique-1280.webp", srcSet: "/img/boutique-640.webp 640w, /img/boutique-1280.webp 1280w", fr: "Équipe souriante dans une boutique de vêtements à Maurice", en: "Smiling retail team in a clothing boutique in Mauritius" },
  cashier: { src: "/img/cashier-1280.webp", srcSet: "/img/cashier-640.webp 640w, /img/cashier-1280.webp 1280w", fr: "Caissière souriante à la caisse d'un supermarché", en: "Smiling cashier at a supermarket checkout" },
  interview: { src: "/img/interview-1280.webp", srcSet: "/img/interview-640.webp 640w, /img/interview-1280.webp 1280w", fr: "Un commerçant fait passer un entretien à une candidate dans sa boutique", en: "A shop owner interviewing a candidate in his shop" },
  welcome: { src: "/img/welcome-1280.webp", srcSet: "/img/welcome-640.webp 640w, /img/welcome-1280.webp 1280w", fr: "Équipe accueillante devant l'entrée d'un magasin", en: "Welcoming retail team at a shop entrance" },
};

export const fmtDate = (d, lang) => (d ? new Date(d).toLocaleDateString(lang === "fr" ? "fr-FR" : "en-GB", { day: "numeric", month: "short", year: "numeric" }) : "");
export const fmtDateTime = (d, lang) => (d ? new Date(d).toLocaleString(lang === "fr" ? "fr-FR" : "en-GB", { day: "numeric", month: "short", hour: "2-digit", minute: "2-digit" }) : "");
